// extracted by css-extract-rspack-plugin
export default {"modal":"q41IEj8VTPES_FGT","header":"N9s7R7QTXfgQPuVy","titleWrapper":"oEtXXboHhpEReDOL","ApprovalRequestButtonContainer":"mkvSIxjnYzI5YlXQ"};